import React from "react";
import { styled } from "../../../../stitches.config";
import Link from "../../../Link";
//https://github.com/mobxjs/mobx-react/issues/256#issuecomment-335301953

import { ICompletedProject } from "./BridCompletedProjects";
import * as S from "./common/styles/Styles";
import { withThemeContext } from "../../../../redesign/components/StitchesThemeProvider";

const CompletedProject: React.FC<ICompletedProject> = ({
  picture,
  brid_donation_progress,
  url,
  title,
  amount,
  reqAmount,
  author,
  finished,
  timeLeft,
  isDarkMode
}) => {
  const progress: number = Math.round(
    (brid_donation_progress.amount / brid_donation_progress.reqAmount) * 100
  );
  return (
    <Wrap>
      <ImageContainer>
        <a href={url}>
          <img src={picture.img} />
        </a>
      </ImageContainer>
      <Sub isDarkMode={isDarkMode}>
        <a href={url}>{title}</a>
        {brid_donation_progress.reqAmount > 0 && (
          <Collected>
            Zebrano: <b>{brid_donation_progress.amount}</b>{" "}
            <span>z {brid_donation_progress.reqAmount} zł</span>
          </Collected>
        )}
        {window.innerWidth > 996 && finished && (
          <div>
            <S.CircleImg diameter={20} src={author.img} />{" "}
            <span>{author.name}</span>
          </div>
        )}
        {brid_donation_progress.reqAmount > 0 &&
          (finished || (
            <React.Fragment>
              <Progress css={{
                "$$width": `${progress}%`
              }}/>
              <TimeLeft>
                Koniec: <span>{brid_donation_progress?.endDate_text}</span>
              </TimeLeft>
            </React.Fragment>
          ))}
      </Sub>
    </Wrap>
  );
};

const Sub = styled("div", {
  "div": {
    margin: "30px auto 9px 20px",
    "span": {
      fontSize: "12px",
      lineHeight: 1.5,
      letterSpacing: "-0.34px",
      color: "#272424"
    }
  },
  "a": {
    display: "block",
    /* margin: 20px 13px; */
    overflow: "hidden",
    fontSize: "16px",
    fontWeight: 700,
    color: "#272424",
    marginTop: "16px",
    filter: "invert(0)"
  },
  "@media (min-width: 992px)": {
    "a": {
      fontSize: "24px"
    }
  },
  variants: {
    "isDarkMode": {
      true: {
        "a": {
          filter: "invert(1)"
        }
      },
      false: {}
    }
  }
});

const ImageContainer = styled("div", {
  height: "50vw",
  maxHeight: "350px",
  width: "300px",
  "img": {
    width: "100%",
    height: "100%",
    maxHeight: "inherit",
    objectFit: "cover"
  },
  "@bp3": {
    height: "15vw",
    maxHeight: "200px",
    width: "auto"
  }
});

const Collected = styled("span", {
  display: "block",
  margin: "18px 13px 0 13px",
  fontSize: "14px",
  fontWeight: "normal",
  color: "#737373",
  "span": {
    color: "#737373"
  },
  "b": {
    color: "#272424"
  },
  "@media (min-width: 992px)": {
    color: "#272424",
    "span": {
      color: "#737373"
    }
  }
});

const TimeLeft = styled("span", {
  display: "block",
  marginLeft: "13px",
  fontSize: "14px",
  width: "auto",
  color: "#737373",
  span: {
    color: "red"
  }
});

const Progress = styled("span", {
  display: "block",
  position: "relative",
  width: "auto",
  height: "6px",
  borderRadius: "5px 0 0 5px",
  margin: "0px 13px",
  backgroundColor: "#eeeff3",
  "&:before": {
    content: "",
    position: "absolute",
    top: "0",
    left: "0",
    width: "$$width",
    maxWidth: "100%",
    height: "4px",
    borderRadius: "5px",
    backgroundColor: "black",
    border: "3px solid black"
  }
});

const Wrap = styled("div", {
  borderRadius: "5px",
  width: "90%",
  maxWidth: "300px",
  margin: "20px 0",
  marginRight: "16px",
  "@media (min-width: 992px)": {
    marginRight: "0",
    maxWidth: "30%"
  }
});

export default withThemeContext(CompletedProject);
